const textDefaults = {
	'EN': {
		'welcomeTitle': 'Let\'s onboard your company.',
		'welcomeReason': 'Complete all steps to finalize your company profile and gain access to the Company Portal.',
		'finishedTitle': 'Ready to submit',
		'finishedReason': 'On submitting, the data you provided will be carefully reviewed and additional checks might be necessary.',
		'vatText': 'Please provide the VAT number:',
		'lblVAT': 'VAT number',
		'unknownCompanyText': 'This VAT number is not recognised and cannot be validated, please recheck or enter all information manually.',
		'unknownCompanyBtn': 'Continue',
		'detailsText': 'Please review and adjust these details if required:',
		'detailsUnknownText': 'Please provide the following details',
		'legalFormHeader': 'Select your Company\'s Legal Form',
		'legalFormText': 'The legal form of your company is defined by its employment status and ownership structure. Please select the option that accurately reflects whether your company has employees who are not the owner, as this affects your compliance requirements.',
		'lblLegalForm': 'Legal form',
		'legalFormSelfEmployed': 'Organisation without employees: Sole Proprietor or Management Company',
		'legalFormCompany': 'Organisation with one or more employees who are not the Company Owner',
		'apiUnavailableWarning': 'Company information could not be loaded from the API. Please fill in the details manually.',
	},
	'FR': {
		'welcomeTitle': 'Intégrons votre entreprise.',
		'welcomeReason': 'Complétez toutes les étapes pour finaliser le profil de votre entreprise et accéder au Portail Entreprise.',
		'finishedTitle': 'Prêt à soumettre',
		'finishedReason': 'Après soumission, les données que vous avez fournies seront soigneusement examinées et des vérifications supplémentaires pourraient être nécessaires.',
		'vatText': 'Veuillez fournir le numéro de TVA :',
		'lblVAT': 'Numéro de TVA',
		'unknownCompanyText': 'Ce numéro de TVA n\'est pas reconnu et ne peut pas être validé, veuillez vérifier à nouveau ou saisir toutes les informations manuellement.',
		'unknownCompanyBtn': 'Continuer',
		'detailsText': 'Veuillez vérifier et ajuster ces détails si nécessaire :',
		'detailsUnknownText': 'Veuillez fournir les détails suivants',
		'legalFormHeader': 'Sélectionnez la forme juridique de votre entreprise',
		'legalFormText': 'La forme juridique de votre entreprise est définie par son statut d\'emploi et sa structure de propriété. Veuillez sélectionner l\'option qui reflète avec précision si votre entreprise a des employés qui ne sont pas le propriétaire, car cela affecte vos exigences de conformité.',
		'lblLegalForm': 'Forme juridique',
		'legalFormSelfEmployed': 'Organisation sans employés : Propriétaire unique ou Société de gestion',
		'legalFormCompany': 'Organisation avec un ou plusieurs employés qui ne sont pas le propriétaire de l\'entreprise',
		'apiUnavailableWarning': 'Les informations de l\'entreprise n\'ont pas pu être chargées depuis l\'API. Veuillez remplir les détails manuellement.',
	},
	'NL': {
		'welcomeTitle': 'Laten we uw bedrijf onboarden.',
		'welcomeReason': 'Voltooi alle stappen om uw bedrijfsprofiel te finaliseren en toegang te krijgen tot het Bedrijfsportaal.',
		'finishedTitle': 'Klaar om in te dienen',
		'finishedReason': 'Na indiening zullen de door u verstrekte gegevens zorgvuldig worden beoordeeld en kunnen aanvullende controles nodig zijn.',
		'vatText': 'Geef het BTW-nummer op:',
		'lblVAT': 'BTW-nummer',
		'unknownCompanyText': 'Dit BTW-nummer wordt niet herkend en kan niet worden gevalideerd. Controleer het opnieuw of voer alle informatie handmatig in.',
		'unknownCompanyBtn': 'Doorgaan',
		'detailsText': 'Controleer en pas deze gegevens aan indien nodig:',
		'detailsUnknownText': 'Geef de volgende gegevens op',
		'legalFormHeader': 'Selecteer de rechtsvorm van uw bedrijf',
		'legalFormText': 'De rechtsvorm van uw bedrijf wordt bepaald door de arbeidsstatus en eigendomsstructuur. Selecteer de optie die nauwkeurig weergeeft of uw bedrijf werknemers heeft die niet de eigenaar zijn, aangezien dit van invloed is op uw nalevingsvereisten.',
		'lblLegalForm': 'Rechtsvorm',
		'legalFormSelfEmployed': 'Organisatie zonder werknemers: Eenmanszaak of Beheersvennootschap',
		'legalFormCompany': 'Organisatie met een of meer werknemers die niet de bedrijfseigenaar zijn',
		'apiUnavailableWarning': 'Bedrijfsinformatie kon niet worden geladen vanuit de API. Vul de gegevens handmatig in.',
	},
	'DE': {
		'welcomeTitle': 'Lassen Sie uns Ihr Unternehmen integrieren.',
		'welcomeReason': 'Vervollständigen Sie alle Schritte, um Ihr Unternehmensprofil abzuschließen und Zugang zum Unternehmensportal zu erhalten.',
		'finishedTitle': 'Bereit zum Absenden',
		'finishedReason': 'Nach dem Absenden werden die von Ihnen angegebenen Daten sorgfältig überprüft und möglicherweise zusätzliche Kontrollen durchgeführt.',
		'vatText': 'Bitte geben Sie die Umsatzsteuer-Identifikationsnummer an:',
		'lblVAT': 'USt-IdNr.',
		'unknownCompanyText': 'Diese USt-IdNr. wird nicht erkannt und kann nicht validiert werden. Bitte überprüfen Sie sie erneut oder geben Sie alle Informationen manuell ein.',
		'unknownCompanyBtn': 'Fortfahren',
		'detailsText': 'Bitte überprüfen und passen Sie diese Details gegebenenfalls an:',
		'detailsUnknownText': 'Bitte geben Sie die folgenden Details an',
		'legalFormHeader': 'Wählen Sie die Rechtsform Ihres Unternehmens',
		'legalFormText': 'Die Rechtsform Ihres Unternehmens wird durch den Beschäftigungsstatus und die Eigentumsstruktur definiert. Bitte wählen Sie die Option, die genau widerspiegelt, ob Ihr Unternehmen Mitarbeiter hat, die nicht der Eigentümer sind, da dies Ihre Compliance-Anforderungen beeinflusst.',
		'lblLegalForm': 'Rechtsform',
		'legalFormSelfEmployed': 'Organisation ohne Mitarbeiter: Einzelunternehmer oder Verwaltungsgesellschaft',
		'legalFormCompany': 'Organisation mit einem oder mehreren Mitarbeitern, die nicht der Unternehmenseigentümer sind',
		'apiUnavailableWarning': 'Unternehmensinformationen konnten nicht von der API geladen werden. Bitte füllen Sie die Details manuell aus.',
	},
	'PL': {
		'welcomeTitle': 'Zintegrujmy Twoją firmę.',
		'welcomeReason': 'Uzupełnij wszystkie kroki, aby sfinalizować profil firmy i uzyskać dostęp do Portalu Firmowego.',
		'finishedTitle': 'Gotowe do wysłania',
		'finishedReason': 'Po wysłaniu, podane przez Ciebie dane zostaną dokładnie sprawdzone i mogą być konieczne dodatkowe weryfikacje.',
		'vatText': 'Proszę podać numer VAT:',
		'lblVAT': 'Numer VAT',
		'unknownCompanyText': 'Ten numer VAT nie jest rozpoznawany i nie może być zweryfikowany, proszę sprawdzić ponownie lub wprowadzić wszystkie informacje ręcznie.',
		'unknownCompanyBtn': 'Kontynuuj',
		'detailsText': 'Proszę sprawdzić i dostosować te szczegóły, jeśli to konieczne:',
		'detailsUnknownText': 'Proszę podać następujące szczegóły',
		'legalFormHeader': 'Wybierz formę prawną swojej firmy',
		'legalFormText': 'Forma prawna Twojej firmy jest określona przez status zatrudnienia i strukturę własności. Proszę wybrać opcję, która dokładnie odzwierciedla, czy Twoja firma ma pracowników, którzy nie są właścicielem, ponieważ wpływa to na wymagania dotyczące zgodności.',
		'lblLegalForm': 'Forma prawna',
		'legalFormSelfEmployed': 'Organizacja bez pracowników: Jednoosobowa działalność gospodarcza lub Spółka zarządcza',
		'legalFormCompany': 'Organizacja z jednym lub większą liczbą pracowników, którzy nie są właścicielem firmy',
		'apiUnavailableWarning': 'Informacje o firmie nie mogły zostać załadowane z API. Proszę wypełnić szczegóły ręcznie.',
	},
	'BG': {
		'welcomeTitle': 'Нека интегрираме вашата компания.',
		'welcomeReason': 'Завършете всички стъпки, за да финализирате профила на вашата компания и да получите достъп до Корпоративния портал.',
		'finishedTitle': 'Готово за изпращане',
		'finishedReason': 'При изпращане, предоставените данни ще бъдат внимателно прегледани и може да са необходими допълнителни проверки.',
		'vatText': 'Моля, предоставете номер за ДДС:',
		'lblVAT': 'Номер за ДДС',
		'unknownCompanyText': 'Този номер за ДДС не е разпознат и не може да бъде валидиран, моля проверете отново или въведете цялата информация ръчно.',
		'unknownCompanyBtn': 'Продължи',
		'detailsText': 'Моля, прегледайте и коригирайте тези данни, ако е необходимо:',
		'detailsUnknownText': 'Моля, предоставете следните данни',
		'legalFormHeader': 'Изберете правната форма на вашата компания',
		'legalFormText': 'Правната форма на вашата компания се определя от статуса на заетост и структурата на собствеността. Моля, изберете опцията, която точно отразява дали вашата компания има служители, които не са собственик, тъй като това влияе на изискванията ви за съответствие.',
		'lblLegalForm': 'Правна форма',
		'legalFormSelfEmployed': 'Организация без служители: Едноличен търговец или Управляваща компания',
		'legalFormCompany': 'Организация с един или повече служители, които не са собственик на компанията',
		'apiUnavailableWarning': 'Информацията за компанията не може да бъде заредена от API. Моля, попълнете детайлите ръчно.',
	},
	'CS': {
		'welcomeTitle': 'Pojďme integrovat vaši společnost.',
		'welcomeReason': 'Dokončete všechny kroky pro dokončení profilu vaší společnosti a získání přístupu k Firemnímu portálu.',
		'finishedTitle': 'Připraveno k odeslání',
		'finishedReason': 'Po odeslání budou poskytnuté údaje pečlivě zkontrolovány a mohou být nutné další kontroly.',
		'vatText': 'Uveďte prosím DIČ:',
		'lblVAT': 'DIČ',
		'unknownCompanyText': 'Toto DIČ není rozpoznáno a nelze ho ověřit, zkontrolujte prosím znovu nebo zadejte všechny informace ručně.',
		'unknownCompanyBtn': 'Pokračovat',
		'detailsText': 'Zkontrolujte a upravte tyto podrobnosti, pokud je to nutné:',
		'detailsUnknownText': 'Uveďte prosím následující údaje',
		'legalFormHeader': 'Vyberte právní formu vaší společnosti',
		'legalFormText': 'Právní forma vaší společnosti je definována statusem zaměstnání a vlastnickou strukturou. Prosím vyberte možnost, která přesně odráží, zda vaše společnost má zaměstnance, kteří nejsou vlastníkem, protože to ovlivňuje vaše požadavky na soulad.',
		'lblLegalForm': 'Právní forma',
		'legalFormSelfEmployed': 'Organizace bez zaměstnanců: Fyzická osoba podnikající nebo Řídící společnost',
		'legalFormCompany': 'Organizace s jedním nebo více zaměstnanci, kteří nejsou vlastníkem společnosti',
		'apiUnavailableWarning': 'Informace o společnosti nemohly být načteny z API. Vyplňte prosím údaje ručně.',
	},
	'DA': {
		'welcomeTitle': 'Lad os integrere jeres virksomhed.',
		'welcomeReason': 'Fuldfør alle trin for at afslutte jeres virksomhedsprofil og få adgang til Virksomhedsportalen.',
		'finishedTitle': 'Klar til at indsende',
		'finishedReason': 'Ved indsendelse vil de data, du har angivet, blive gennemgået nøje, og der kan være behov for yderligere kontroller.',
		'vatText': 'Angiv venligst CVR-nummeret:',
		'lblVAT': 'CVR-nummer',
		'unknownCompanyText': 'Dette CVR-nummer genkendes ikke og kan ikke valideres. Kontrollér venligst igen eller indtast alle oplysninger manuelt.',
		'unknownCompanyBtn': 'Fortsæt',
		'detailsText': 'Gennemgå venligst og justér disse detaljer, hvis det er nødvendigt:',
		'detailsUnknownText': 'Angiv venligst følgende oplysninger',
		'legalFormHeader': 'Vælg jeres virksomheds retsform',
		'legalFormText': 'Jeres virksomheds retsform er defineret af ansættelsesstatus og ejerskabsstruktur. Vælg venligst den mulighed, der nøjagtigt afspejler, om jeres virksomhed har medarbejdere, der ikke er ejeren, da dette påvirker jeres overholdelseskrav.',
		'lblLegalForm': 'Retsform',
		'legalFormSelfEmployed': 'Organisation uden medarbejdere: Enkeltmandsvirksomhed eller Administrationsselskab',
		'legalFormCompany': 'Organisation med en eller flere medarbejdere, der ikke er virksomhedsejeren',
		'apiUnavailableWarning': 'Virksomhedsoplysninger kunne ikke indlæses fra API. Udfyld venligst detaljerne manuelt.',
	},
	'ES': {
		'welcomeTitle': 'Integremos su empresa.',
		'welcomeReason': 'Complete todos los pasos para finalizar el perfil de su empresa y obtener acceso al Portal Empresarial.',
		'finishedTitle': 'Listo para enviar',
		'finishedReason': 'Al enviar, los datos proporcionados serán revisados cuidadosamente y podrían ser necesarias verificaciones adicionales.',
		'vatText': 'Proporcione el número de IVA:',
		'lblVAT': 'Número de IVA',
		'unknownCompanyText': 'Este número de IVA no es reconocido y no se puede validar. Por favor, verifique nuevamente o ingrese toda la información manualmente.',
		'unknownCompanyBtn': 'Continuar',
		'detailsText': 'Revise y ajuste estos detalles si es necesario:',
		'detailsUnknownText': 'Proporcione los siguientes datos',
		'legalFormHeader': 'Seleccione la forma jurídica de su empresa',
		'legalFormText': 'La forma jurídica de su empresa está definida por su estado de empleo y estructura de propiedad. Por favor, seleccione la opción que refleje con precisión si su empresa tiene empleados que no son el propietario, ya que esto afecta sus requisitos de cumplimiento.',
		'lblLegalForm': 'Forma jurídica',
		'legalFormSelfEmployed': 'Organización sin empleados: Propietario único o Sociedad de gestión',
		'legalFormCompany': 'Organización con uno o más empleados que no son el propietario de la empresa',
		'apiUnavailableWarning': 'La información de la empresa no pudo cargarse desde la API. Por favor, complete los detalles manualmente.',
	},
	'FI': {
		'welcomeTitle': 'Integroidaan yrityksenne.',
		'welcomeReason': 'Suorita kaikki vaiheet yrityksenne profiilin viimeistelyä varten ja saadaksesi pääsyn Yritysportaaliin.',
		'finishedTitle': 'Valmis lähettämään',
		'finishedReason': 'Lähettämisen jälkeen antamasi tiedot tarkistetaan huolellisesti ja mahdollisia lisätarkistuksia voi olla tarpeen.',
		'vatText': 'Anna ALV-numero:',
		'lblVAT': 'ALV-numero',
		'unknownCompanyText': 'Tämä ALV-numeroa ei tunnisteta eikä sitä voida validoida. Tarkista se uudelleen tai syötä kaikki tiedot manuaalisesti.',
		'unknownCompanyBtn': 'Jatka',
		'detailsText': 'Tarkista ja muokkaa näitä tietoja tarvittaessa:',
		'detailsUnknownText': 'Anna seuraavat tiedot',
		'legalFormHeader': 'Valitse yrityksenne oikeudellinen muoto',
		'legalFormText': 'Yrityksenne oikeudellinen muoto määritellään työllisyystilalla ja omistusrakenteella. Valitse vaihtoehto, joka kuvastaa tarkasti, onko yrityksellänne työntekijöitä, jotka eivät ole omistaja, koska tämä vaikuttaa noudattamisvaatimuksiinne.',
		'lblLegalForm': 'Oikeudellinen muoto',
		'legalFormSelfEmployed': 'Organisaatio ilman työntekijöitä: Yksityisyrittäjä tai Hallintoyhtiö',
		'legalFormCompany': 'Organisaatio, jossa on yksi tai useampi työntekijä, jotka eivät ole yrityksen omistaja',
		'apiUnavailableWarning': 'Yritystiedot eivät voineet ladata API:sta. Täytä tiedot manuaalisesti.',
	},
	'HR': {
		'welcomeTitle': 'Integrirajmo vašu tvrtku.',
		'welcomeReason': 'Dovršite sve korake za dovršetak profila vaše tvrtke i pristup Portalu tvrtki.',
		'finishedTitle': 'Spremno za slanje',
		'finishedReason': 'Po slanju, podaci koje ste naveli bit će pažljivo pregledani i mogu biti potrebne dodatne provjere.',
		'vatText': 'Molimo navedite OIB:',
		'lblVAT': 'OIB',
		'unknownCompanyText': 'Ovaj OIB nije prepoznat i ne može biti validiran, molimo provjerite ponovno ili unesite sve informacije ručno.',
		'unknownCompanyBtn': 'Nastavi',
		'detailsText': 'Molimo pregledajte i prilagodite ove detalje ako je potrebno:',
		'detailsUnknownText': 'Molimo navedite sljedeće podatke',
		'legalFormHeader': 'Odaberite pravni oblik vaše tvrtke',
		'legalFormText': 'Pravni oblik vaše tvrtke definiran je statusom zaposlenja i strukturom vlasništva. Molimo odaberite opciju koja točno odražava ima li vaša tvrtka zaposlenike koji nisu vlasnik, jer to utječe na vaše zahtjeve za usklađenost.',
		'lblLegalForm': 'Pravni oblik',
		'legalFormSelfEmployed': 'Organizacija bez zaposlenika: Samostalni poduzetnik ili Upravljačko društvo',
		'legalFormCompany': 'Organizacija s jednim ili više zaposlenika koji nisu vlasnik tvrtke',
		'apiUnavailableWarning': 'Podaci o tvrtki nisu mogli biti učitani iz API-ja. Molimo unesite detalje ručno.',
	},
	'HU': {
		'welcomeTitle': 'Integráljuk a vállalkozását.',
		'welcomeReason': 'Végezze el az összes lépést a vállalkozás profiljának befejezéséhez és a Vállalati Portál eléréséhez.',
		'finishedTitle': 'Készen áll a benyújtásra',
		'finishedReason': 'A benyújtás után a megadott adatokat gondosan átnézik, és további ellenőrzések szükségesek lehetnek.',
		'vatText': 'Kérjük, adja meg az ÁFA-számot:',
		'lblVAT': 'ÁFA-szám',
		'unknownCompanyText': 'Ez az ÁFA-szám nem ismerhető fel és nem validálható. Kérjük, ellenőrizze újra vagy adja meg az összes információt manuálisan.',
		'unknownCompanyBtn': 'Folytatás',
		'detailsText': 'Kérjük, ellenőrizze és szükség esetén módosítsa ezeket a részleteket:',
		'detailsUnknownText': 'Kérjük, adja meg a következő adatokat',
		'legalFormHeader': 'Válassza ki vállalkozása jogi formáját',
		'legalFormText': 'Vállalkozása jogi formáját a foglalkoztatási státusz és a tulajdonosi struktúra határozza meg. Kérjük, válassza ki azt a lehetőséget, amely pontosan tükrözi, hogy vállalkozásának vannak-e olyan alkalmazottai, akik nem a tulajdonos, mivel ez befolyásolja a megfelelőségi követelményeket.',
		'lblLegalForm': 'Jogi forma',
		'legalFormSelfEmployed': 'Szervezet alkalmazottak nélkül: Egyéni vállalkozó vagy Menedzsment társaság',
		'legalFormCompany': 'Szervezet egy vagy több olyan alkalmazottal, aki nem a vállalkozás tulajdonosa',
		'apiUnavailableWarning': 'A vállalkozás adatai nem tölthetők be az API-ból. Kérjük, töltse ki a részleteket manuálisan.',
	},
	'IT': {
		'welcomeTitle': 'Integriamo la vostra azienda.',
		'welcomeReason': 'Completate tutti i passaggi per finalizzare il profilo della vostra azienda e ottenere l\'accesso al Portale Aziendale.',
		'finishedTitle': 'Pronto per l\'invio',
		'finishedReason': 'All\'invio, i dati forniti saranno attentamente revisionati e potrebbero essere necessarie verifiche aggiuntive.',
		'vatText': 'Si prega di fornire la partita IVA:',
		'lblVAT': 'Partita IVA',
		'unknownCompanyText': 'Questa partita IVA non è riconosciuta e non può essere validata. Si prega di verificare di nuovo o inserire tutte le informazioni manualmente.',
		'unknownCompanyBtn': 'Continua',
		'detailsText': 'Si prega di rivedere e regolare questi dettagli, se necessario:',
		'detailsUnknownText': 'Si prega di fornire i seguenti dettagli',
		'legalFormHeader': 'Selezionate la forma giuridica della vostra azienda',
		'legalFormText': 'La forma giuridica della vostra azienda è definita dallo stato di occupazione e dalla struttura di proprietà. Si prega di selezionare l\'opzione che riflette accuratamente se la vostra azienda ha dipendenti che non sono il proprietario, poiché ciò influisce sui requisiti di conformità.',
		'lblLegalForm': 'Forma giuridica',
		'legalFormSelfEmployed': 'Organizzazione senza dipendenti: Ditta individuale o Società di gestione',
		'legalFormCompany': 'Organizzazione con uno o più dipendenti che non sono il proprietario dell\'azienda',
		'apiUnavailableWarning': 'Le informazioni sull\'azienda non sono state caricate dall\'API. Si prega di compilare i dettagli manualmente.',
	},
	'NO': {
		'welcomeTitle': 'La oss integrere bedriften deres.',
		'welcomeReason': 'Fullfør alle trinnene for å finalisere bedriftsprofilen deres og få tilgang til Bedriftsportalen.',
		'finishedTitle': 'Klar til innsending',
		'finishedReason': 'Ved innsending vil de dataene du har oppgitt bli nøye gjennomgått, og det kan være behov for ytterligere kontroller.',
		'vatText': 'Angi vennligst VAT-nummeret:',
		'lblVAT': 'VAT-nummer',
		'unknownCompanyText': 'Dette VAT-nummeret er ikke godkjent og kan ikke valideres. Kontroller det på nytt eller oppgi all informasjon manuelt.',
		'unknownCompanyBtn': 'Fortsett',
		'detailsText': 'Gjennomgå og juster disse detaljene om nødvendig:',
		'detailsUnknownText': 'Oppgi følgende opplysninger',
		'legalFormHeader': 'Velg bedriftens rettsform',
		'legalFormText': 'Bedriftens rettsform er definert av ansettelsesstatus og eierstruktur. Vennligst velg alternativet som nøyaktig reflekterer om bedriften har ansatte som ikke er eieren, da dette påvirker deres overholdelseskrav.',
		'lblLegalForm': 'Rettsform',
		'legalFormSelfEmployed': 'Organisasjon uten ansatte: Enkeltpersonforetak eller Administrasjonsselskap',
		'legalFormCompany': 'Organisasjon med en eller flere ansatte som ikke er bedriftseieren',
		'apiUnavailableWarning': 'Bedriftsinformasjon kunne ikke lastes fra API. Fyll ut detaljene manuelt.',
	},
	'PT': {
		'welcomeTitle': 'Vamos integrar a sua empresa.',
		'welcomeReason': 'Complete todos os passos para finalizar o perfil da sua empresa e obter acesso ao Portal Empresarial.',
		'finishedTitle': 'Pronto para enviar',
		'finishedReason': 'Ao enviar, os dados fornecidos serão cuidadosamente revisados e verificações adicionais poderão ser necessárias.',
		'vatText': 'Por favor, forneça o número de IVA:',
		'lblVAT': 'Número de IVA',
		'unknownCompanyText': 'Este número de IVA não é reconhecido e não pode ser validado. Por favor, verifique novamente ou insira todas as informações manualmente.',
		'unknownCompanyBtn': 'Continuar',
		'detailsText': 'Revise e ajuste estes detalhes, se necessário:',
		'detailsUnknownText': 'Por favor, forneça os seguintes detalhes',
		'legalFormHeader': 'Selecione a forma jurídica da sua empresa',
		'legalFormText': 'A forma jurídica da sua empresa é definida pelo status de emprego e estrutura de propriedade. Por favor, selecione a opção que reflete com precisão se a sua empresa tem funcionários que não são o proprietário, pois isso afeta os seus requisitos de conformidade.',
		'lblLegalForm': 'Forma jurídica',
		'legalFormSelfEmployed': 'Organização sem funcionários: Proprietário único ou Sociedade de gestão',
		'legalFormCompany': 'Organização com um ou mais funcionários que não são o proprietário da empresa',
		'apiUnavailableWarning': 'As informações da empresa não puderam ser carregadas da API. Por favor, preencha os detalhes manualmente.',
	},
	'RO': {
		'welcomeTitle': 'Să integrăm compania dvs.',
		'welcomeReason': 'Finalizați toți pașii pentru a finaliza profilul companiei dvs. și a obține acces la Portalul Companiei.',
		'finishedTitle': 'Gata de trimis',
		'finishedReason': 'La trimitere, datele furnizate vor fi examinate cu atenție și pot fi necesare verificări suplimentare.',
		'vatText': 'Vă rugăm să furnizați numărul de TVA:',
		'lblVAT': 'Număr de TVA',
		'unknownCompanyText': 'Acest număr de TVA nu este recunoscut și nu poate fi validat. Vă rugăm să verificați din nou sau introduceți toate informațiile manual.',
		'unknownCompanyBtn': 'Continuă',
		'detailsText': 'Vă rugăm să revizuiți și să ajustați aceste detalii, dacă este necesar:',
		'detailsUnknownText': 'Vă rugăm să furnizați următoarele detalii',
		'legalFormHeader': 'Selectați forma juridică a companiei dvs.',
		'legalFormText': 'Forma juridică a companiei dvs. este definită de statusul de angajare și structura de proprietate. Vă rugăm să selectați opțiunea care reflectă cu exactitate dacă compania dvs. are angajați care nu sunt proprietarul, deoarece acest lucru afectează cerințele dvs. de conformitate.',
		'lblLegalForm': 'Forma juridică',
		'legalFormSelfEmployed': 'Organizație fără angajați: Proprietar unic sau Societate de management',
		'legalFormCompany': 'Organizație cu unul sau mai mulți angajați care nu sunt proprietarul companiei',
		'apiUnavailableWarning': 'Informațiile despre companie nu au putut fi încărcate din API. Vă rugăm să completați detaliile manual.',
	},
	'RU': {
		'welcomeTitle': 'Давайте интегрируем вашу компанию.',
		'welcomeReason': 'Завершите все шаги для завершения профиля вашей компании и получения доступа к Корпоративному порталу.',
		'finishedTitle': 'Готово к отправке',
		'finishedReason': 'При отправке предоставленные данные будут тщательно проверены, могут потребоваться дополнительные проверки.',
		'vatText': 'Укажите номер НДС:',
		'lblVAT': 'Номер НДС',
		'unknownCompanyText': 'Этот номер НДС не распознан и не может быть подтвержден. Пожалуйста, проверьте еще раз или введите всю информацию вручную.',
		'unknownCompanyBtn': 'Продолжить',
		'detailsText': 'Пожалуйста, просмотрите и при необходимости скорректируйте эти данные:',
		'detailsUnknownText': 'Пожалуйста, предоставьте следующие данные',
		'legalFormHeader': 'Выберите правовую форму вашей компании',
		'legalFormText': 'Правовая форма вашей компании определяется статусом занятости и структурой собственности. Пожалуйста, выберите вариант, который точно отражает, есть ли у вашей компании сотрудники, которые не являются владельцем, поскольку это влияет на ваши требования соответствия.',
		'lblLegalForm': 'Правовая форма',
		'legalFormSelfEmployed': 'Организация без сотрудников: Индивидуальный предприниматель или Управляющая компания',
		'legalFormCompany': 'Организация с одним или несколькими сотрудниками, которые не являются владельцем компании',
		'apiUnavailableWarning': 'Информация о компании не может быть загружена из API. Пожалуйста, заполните детали вручную.',
	},
	'SK': {
		'welcomeTitle': 'Integrujme vašu spoločnosť.',
		'welcomeReason': 'Dokončite všetky kroky na dokončenie profilu vašej spoločnosti a získanie prístupu k Firemnému portálu.',
		'finishedTitle': 'Pripravené na odoslanie',
		'finishedReason': 'Po odoslaní budú poskytnuté údaje dôkladne preskúmané a môžu byť potrebné dodatočné kontroly.',
		'vatText': 'Uveďte prosím DIČ:',
		'lblVAT': 'DIČ',
		'unknownCompanyText': 'Toto DIČ nie je rozpoznané a nemôže byť overené. Skontrolujte to prosím znova alebo zadajte všetky informácie ručne.',
		'unknownCompanyBtn': 'Pokračovať',
		'detailsText': 'Skontrolujte a upravte tieto podrobnosti, ak je to nutné:',
		'detailsUnknownText': 'Uveďte prosím nasledujúce údaje',
		'legalFormHeader': 'Vyberte právnu formu vašej spoločnosti',
		'legalFormText': 'Právna forma vašej spoločnosti je definovaná statusom zamestnania a vlastníckou štruktúrou. Prosím vyberte možnosť, ktorá presne odráža, či vaša spoločnosť má zamestnancov, ktorí nie sú vlastníkom, pretože to ovplyvňuje vaše požiadavky na súlad.',
		'lblLegalForm': 'Právna forma',
		'legalFormSelfEmployed': 'Organizácia bez zamestnancov: Fyzická osoba podnikajúca alebo Riadiaca spoločnosť',
		'legalFormCompany': 'Organizácia s jedným alebo viacerými zamestnancami, ktorí nie sú vlastníkom spoločnosti',
		'apiUnavailableWarning': 'Informácie o spoločnosti sa nepodarilo načítať z API. Vyplňte prosím údaje ručne.',
	},
	'SI': {
		'welcomeTitle': 'Integrirajmo vaše podjetje.',
		'welcomeReason': 'Dokončajte vse korake za dokončanje profila vašega podjetja in dostop do Podjetniškega portala.',
		'finishedTitle': 'Pripravljeno za oddajo',
		'finishedReason': 'Po oddaji bodo navedeni podatki skrbno pregledani in morda bodo potrebne dodatne preveritve.',
		'vatText': 'Prosimo, navedite ID za DDV:',
		'lblVAT': 'ID za DDV',
		'unknownCompanyText': 'Ta ID za DDV ni prepoznan in ni mogoče validirati. Prosimo, preverite ponovno ali vnesite vse informacije ročno.',
		'unknownCompanyBtn': 'Nadaljuj',
		'detailsText': 'Prosimo, pregledajte in prilagodite te podrobnosti, če je potrebno:',
		'detailsUnknownText': 'Prosimo, navedite naslednje podrobnosti',
		'legalFormHeader': 'Izberite pravno obliko vašega podjetja',
		'legalFormText': 'Pravna oblika vašega podjetja je določena s statusom zaposlitve in lastniško strukturo. Prosimo izberite možnost, ki natančno odraža, ali ima vaše podjetje zaposlene, ki niso lastnik, saj to vpliva na vaše zahteve za skladnost.',
		'lblLegalForm': 'Pravna oblika',
		'legalFormSelfEmployed': 'Organizacija brez zaposlenih: Samostojni podjetnik ali Upravljalno podjetje',
		'legalFormCompany': 'Organizacija z enim ali več zaposlenimi, ki niso lastnik podjetja',
		'apiUnavailableWarning': 'Podatki o podjetju niso mogli biti naloženi iz API-ja. Prosimo, izpolnite podrobnosti ročno.',
	},
	'SV': {
		'welcomeTitle': 'Låt oss integrera ditt företag.',
		'welcomeReason': 'Slutför alla steg för att slutföra ditt företagsprofil och få tillgång till Företagsportalen.',
		'finishedTitle': 'Redo att skicka',
		'finishedReason': 'Vid skickande kommer de uppgifter du har angett att noggrant granskas och ytterligare kontroller kan vara nödvändiga.',
		'vatText': 'Ange momsregistreringsnummer:',
		'lblVAT': 'Momsregistreringsnummer',
		'unknownCompanyText': 'Detta momsregistreringsnummer känns inte igen och kan inte verifieras. Kontrollera igen eller ange all information manuellt.',
		'unknownCompanyBtn': 'Fortsätt',
		'detailsText': 'Granska och justera dessa uppgifter vid behov:',
		'detailsUnknownText': 'Ange följande uppgifter',
		'legalFormHeader': 'Välj ditt företags rättsform',
		'legalFormText': 'Ditt företags rättsform definieras av anställningsstatus och ägarstruktur. Vänligen välj alternativet som exakt återspeglar om ditt företag har anställda som inte är ägaren, eftersom detta påverkar dina efterlevnadskrav.',
		'lblLegalForm': 'Rättsform',
		'legalFormSelfEmployed': 'Organisation utan anställda: Enskild firma eller Förvaltningsbolag',
		'legalFormCompany': 'Organisation med en eller flera anställda som inte är företagsägaren',
		'apiUnavailableWarning': 'Företagsinformation kunde inte laddas från API. Fyll i detaljerna manuellt.',
	},
	'TR': {
		'welcomeTitle': 'Şirketinizi entegre edelim.',
		'welcomeReason': 'Şirket profilinizi tamamlamak ve Şirket Portalına erişim sağlamak için tüm adımları tamamlayın.',
		'finishedTitle': 'Göndermeye hazır',
		'finishedReason': 'Gönderildiğinde, sağladığınız veriler dikkatle incelenecek ve ek kontroller gerekebilir.',
		'vatText': 'KDV numarasını girin:',
		'lblVAT': 'KDV numarası',
		'unknownCompanyText': 'Bu KDV numarası tanınmıyor ve doğrulanamıyor. Lütfen tekrar kontrol edin veya tüm bilgileri manuel olarak girin.',
		'unknownCompanyBtn': 'Devam',
		'detailsText': 'Bu ayrıntıları gözden geçirin ve gerekiyorsa ayarlayın:',
		'detailsUnknownText': 'Lütfen aşağıdaki ayrıntıları sağlayın',
		'legalFormHeader': 'Şirketinizin hukuki şeklini seçin',
		'legalFormText': 'Şirketinizin hukuki şekli, istihdam durumu ve mülkiyet yapısı tarafından belirlenir. Lütfen şirketinizin sahibi olmayan çalışanları olup olmadığını doğru bir şekilde yansıtan seçeneği seçin, çünkü bu uyum gereksinimlerinizi etkiler.',
		'lblLegalForm': 'Hukuki şekil',
		'legalFormSelfEmployed': 'Çalışanı olmayan organizasyon: Tek Sahipli İşletme veya Yönetim Şirketi',
		'legalFormCompany': 'Şirket sahibi olmayan bir veya daha fazla çalışanı olan organizasyon',
		'apiUnavailableWarning': 'Şirket bilgileri API\'den yüklenemedi. Lütfen detayları manuel olarak doldurun.',
	},
	'UK': {
		'welcomeTitle': 'Давайте інтегруємо вашу компанію.',
		'welcomeReason': 'Завершіть усі кроки для завершення профілю вашої компанії та отримання доступу до Корпоративного порталу.',
		'finishedTitle': 'Готово до відправлення',
		'finishedReason': 'Після відправлення надані дані будуть ретельно перевірені та може знадобитися додаткова перевірка.',
		'vatText': 'Будь ласка, надайте номер ПДВ:',
		'lblVAT': 'Номер ПДВ',
		'unknownCompanyText': 'Цей номер ПДВ не розпізнано і не можна підтвердити. Будь ласка, перевірте знову або введіть всю інформацію вручну.',
		'unknownCompanyBtn': 'Продовжити',
		'detailsText': 'Будь ласка, перевірте та при необхідності скоригуйте ці дані:',
		'detailsUnknownText': 'Будь ласка, надайте такі дані',
		'legalFormHeader': 'Виберіть правову форму вашої компанії',
		'legalFormText': 'Правова форма вашої компанії визначається статусом зайнятості та структурою власності. Будь ласка, виберіть варіант, який точно відображає, чи має ваша компанія співробітників, які не є власником, оскільки це впливає на ваші вимоги до відповідності.',
		'lblLegalForm': 'Правова форма',
		'legalFormSelfEmployed': 'Організація без співробітників: Індивідуальний підприємець або Управляюча компанія',
		'legalFormCompany': 'Організація з одним або кількома співробітниками, які не є власником компанії',
		'apiUnavailableWarning': 'Інформацію про компанію не вдалося завантажити з API. Будь ласка, заповніть деталі вручну.',
	},
};


export function getTextDefaults(lang) {
	return textDefaults[lang.toUpperCase()] || textDefaults['EN'];
}

export function getLanguages() {
	return Object.keys(textDefaults);
}